import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import clsx from "clsx";
interface IInlineNavButton {
  isDisabled: boolean;
  children: React.ReactNode;
  handleClick?: () => void;
}

const InlineNavButton = ({
  handleClick,
  children,
  isDisabled,
}: IInlineNavButton) => (
  <div
    className={clsx(
      "p-2 rounded-lg cursor-pointer transition-all",
      isDisabled ? "text-white/30" : " text-white"
    )}
    {...(!isDisabled && { onClick: handleClick })}
  >
    {children}
  </div>
);

export default function PracticeHistoryNav({
  current,
  total,
  setCurrent,
}: {
  current: number;
  total: number;
  setCurrent: (s: number) => void;
}) {
  return (
    <div className={clsx("inline-flex items-center gap-1 justify-start ml-auto select-none bg-surface-1 border border-white/[0.08] rounded-xl text-sm font-medium p-1.5 translate-x-6 -translate-y-1/2 top-0 absolute z-1", total === 0 && "pointer-events-none opacity-0")}>
      <span
        className={clsx(
          "py-1.5 px-3 transition-all rounded-lg border border-transparent",
          current === -1
            ? "bg-myGb/50 text-white"
            : "text-white/80 cursor-pointer hover:text-white"
        )}
        onClick={() => setCurrent(-1)}
      >
        Yeni cevap
      </span>
      <span
        className={clsx(
          "text-white/80 px-3 py-1.5 cursor-pointer hover:text-white border border-transparent",
          current === -1 ? "" : "hidden"
        )}
        onClick={() => setCurrent(0)}
      >
        Önceki cevaplar ({total})
      </span>
      {total === 0 ? null : (
        <div
          className={clsx(
            "items-center rounded-lg bg-myGb/50",
            current === -1 ? "hidden" : "inline-flex"
          )}
        >
          <InlineNavButton
            handleClick={() => setCurrent(current - 1)}
            isDisabled={current < 0}
          >
            <CaretLeft weight="bold" size={16} />
          </InlineNavButton>
          <span>
            {current + 1}/{total}
          </span>
          <InlineNavButton
            handleClick={() => setCurrent(current + 1)}
            isDisabled={current === total - 1}
          >
            <CaretRight weight="bold" size={16} />
          </InlineNavButton>
        </div>
      )}
    </div>
  );
}
